<ng-container *transloco="let t; prefix: 'login'">
    <div class="overlay-spinner">
        <div class="visually-hidden">{{ t("loadingtext") }}</div>
        <loading-spinner-grow />
    </div>
</ng-container>